var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import WithoutProspecting from '../components/llm/WithoutProspecting.vue';
import FollowUp from '../components/llm/FollowUp.vue';
import NewKanbam from '../components/llm/NewKanbam.vue';
let llmContainer = class llmContainer extends Vue {
    constructor() {
        super(...arguments);
        this.channel = '';
        this.rowFormat = 'json';
        this.page = 1;
        this.limit = 10;
    }
    mounted() {
        this.channel = this.$route.params.channel;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.rowFormat = urlParams.get('formato') || 'json';
        this.page = +(urlParams.get('pagina') || 1);
        this.limit = +(urlParams.get('limite') || 10);
    }
};
llmContainer = __decorate([
    Component({
        name: 'llmContainer',
        components: {
            WithoutProspecting,
            FollowUp,
            NewKanbam,
        },
    })
], llmContainer);
export default llmContainer;
